export const BULK_UPLOAD_URL = 'https://be.image-upload.punjabeforest.gop.pk/v1/bulk';
export const UPLOAD_BUCKET = 'gis-lab-data';
export const DEFAULT_UPLOAD_FOLDER = 'survey-2026';

// Application-wide file selection/upload limits
export const MAX_FILES = 20;
export const MAX_FILE_SIZE = 35 * 1024 * 1024; // 35 MB

const URL_FIELD_NAMES = [
  'url',
  'fileUrl',
  'file_url',
  'downloadUrl',
  'download_url',
  'publicUrl',
  'public_url',
  'location',
  'Location',
  'path',
];

const isUrlLike = (value) => (
  typeof value === 'string' &&
  (/^https?:\/\//i.test(value) || value.startsWith('/'))
);

export const getMediaUrl = (media) => {
  if (isUrlLike(media)) {
    return media;
  }

  if (!media || typeof media !== 'object') {
    return '';
  }

  for (const fieldName of URL_FIELD_NAMES) {
    if (isUrlLike(media[fieldName])) {
      return media[fieldName];
    }
  }

  if (media.availableSizes && typeof media.availableSizes === 'object') {
    return media.availableSizes.thumbnail || media.availableSizes.original || '';
  }

  return '';
};

const collectUploadItems = (payload, items = []) => {
  if (!payload) {
    return items;
  }

  if (Array.isArray(payload)) {
    payload.forEach((item) => collectUploadItems(item, items));
    return items;
  }

  if (typeof payload !== 'object') {
    if (isUrlLike(payload)) {
      items.push({ url: payload });
    }
    return items;
  }

  const url = getMediaUrl(payload);
  if (url) {
    items.push({
      ...payload,
      url,
      originalName: payload.originalName || payload.original_name || payload.fileName || payload.filename || payload.name,
    });
  }

  ['data', 'files', 'uploadedFiles', 'uploadResponses', 'results', 'items'].forEach((fieldName) => {
    collectUploadItems(payload[fieldName], items);
  });

  return items;
};

export const normalizeUploadResponse = (payload) => {
  const seenUrls = new Set();

  return collectUploadItems(payload).filter((item) => {
    if (!item.url || seenUrls.has(item.url)) {
      return false;
    }

    seenUrls.add(item.url);
    return true;
  });
};

export const uploadFilesToImageService = async (files, options = {}) => {
  const formData = new FormData();
  const uploadFiles = Array.isArray(files) ? files : [files];

  uploadFiles.filter(Boolean).forEach((file) => {
    formData.append('files', file);
  });

  formData.append('bucket', options.bucket || UPLOAD_BUCKET);
  formData.append('folder', options.folder || DEFAULT_UPLOAD_FOLDER);

  const response = await fetch(options.url || BULK_UPLOAD_URL, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`File upload failed with status ${response.status}`);
  }

  const responseData = await response.json();
  const uploadedItems = normalizeUploadResponse(responseData);

  if (!uploadedItems.length) {
    throw new Error('File upload failed. No URL found in response.');
  }

  return uploadedItems;
};
